"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findLabelByDomainType = void 0;
const findLabelByDomainType = domainType => label => label?.productLabelDomain === domainType;
exports.findLabelByDomainType = findLabelByDomainType;
